export default __webpack_public_path__ + "static/media/blog-g-1.35b8dc0d.png";